export const SET_BOOKMARK_STATE = (state, { id, value }) => {
  const s = state.data[id];
  if (!s) return;

  if (!s.reactions) s.reactions = {};
  if (!s.reactions.bookmarked) s.reactions.bookmarked = {};

  s.reactions.bookmarked.is_mine = value;
};

export const PIN_SIGNAL = (state, id) => {
  state.data[id].pinned = !state.data[id].pinned;
};

export const MAKE_SIGNAL_TRENDING = (state, { id, status }) => {
  state.data[id].trending = status;
};

export const CHANGE_LIVE_STATUS = (state, { id, status }) => {
  state.data[id].live = status;
};

export const ALIGN_COMMENTS = (state, id) => {
  state.data[id].init_comments_count = state.data[id].comments_count;
};

export const UPDATE_COMMENTS_COUNTER = (state, { id, count }) => {
  const s = state.data[id];
  if (!s) return;

  s.comments_count = count;

  if (s.comments_count < s.init_comments_count) {
    s.init_comments_count = s.comments_count;
  }
};